import type { Filter } from 'client/js/main/components/DrillDownTable/types';

export class DrillDownService {
  public static getDrillDownKey(filters: Filter[]) {
    return filters.map((filter) => filter.value).join('.');
  }
}
